module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "overlay-opacity": "90",
      "width": "360px"
    },
    model: {
      value: (_vm.loginchallenge),
      callback: function($$v) {
        _vm.loginchallenge = $$v
      },
      expression: "loginchallenge"
    }
  }, [_c('v-card', [(_vm.loginchallenge) ? _c('login', {
    attrs: {
      "with-init": false
    },
    on: {
      "loggedin": function($event) {
        _vm.loginchallenge = false;
        _vm.$emit('loggedin')
      }
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721442a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Session.vue
// module id = 1465
// module chunks = 9